import Box from "./Box";
import Divider from "./Divider";
import FadeOutRollover from "./FadeOutRollover";
import React from "react";

function Footer() {
  return (
    <>
      <Divider />
      <Box
        px="4vw"
        pt={25}
        pb={50}
        display="flex"
        flexDirection={["column", "row", null, null]}
      >
        <FadeOutRollover
          pr={[0, 15, null, null]}
          py="7px"
          display="inline-flex"
        >
          <a
            href="https://www.reskinned.clothing/legal/privacy-notice"
            target="_blank"
          >
            Privacy Policy
          </a>
        </FadeOutRollover>
        <FadeOutRollover
          pr={[0, 15, null, null]}
          py="7px"
          display="inline-flex"
        >
          {" "}
          <a
            href="https://www.reskinned.clothing/pages/takeback/takeback-terms-and-conditions"
            target="_blank"
          >
            Terms & Conditions
          </a>
        </FadeOutRollover>
        <FadeOutRollover
          pr={[0, 15, null, null]}
          py="7px"
          display="inline-flex"
        >
          <a
            href="https://www.reskinned.clothing/pages/takeback/takeback-faqs"
            target="_blank"
          >
            FAQs
          </a>
        </FadeOutRollover>
      </Box>
    </>
  );
}

export default Footer;
